import { importProvidersFrom } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';

import { JobToJobListComponent } from './app/widgets/job-to-joblist-widget/job-to-joblist-widget.component';
import { JobDescriptionModelPOPUPComponent } from './app/job-description-model-popup/job-description-model-popup.component';


bootstrapApplication(JobToJobListComponent, {
  providers: [provideAnimations(), provideHttpClient()]
}).then(appRef => {
  const injector = appRef.injector;

  const jobToJobWidgetElement = createCustomElement(JobToJobListComponent, { injector });
  customElements.define('job-job-list', jobToJobWidgetElement);

  const jobDescriptionPopupElement = createCustomElement(JobDescriptionModelPOPUPComponent, { injector });
  customElements.define('job-description-model-popup', jobDescriptionPopupElement);

});
